/* eslint-disable */
import { hasConverted, storeConversion } from './storage';
import { getGroupForExperiment } from './group';
import { onConversion, onEnrollment, onTrialStart } from './tracker';
import { Group } from './types';

type Experiment = {
  onTrialStart: () => void;
  onConversion: () => void;
  isInExperimentGroup: boolean;
};
export const createExperiment = (
  experimentId: string,
  { experimentRate = 0.5, stopOnConversion = true } = {}
): Experiment => {
  if (/[^\w]/.test(experimentId)) {
    throw new Error('experimentId can only include characters, numbers, and underscores');
  }

  const { group, isNewEnrollment } = getGroupForExperiment(experimentId, experimentRate);

  if (isNewEnrollment) {
    onEnrollment(experimentId, group);
  }

  return {
    onTrialStart: () => {
      if (stopOnConversion && hasConverted(experimentId)) {
        return;
      }

      onTrialStart(experimentId, group);
    },
    onConversion: () => {
      if (stopOnConversion && hasConverted(experimentId)) {
        return;
      }

      onConversion(experimentId, group);
      storeConversion(experimentId);
    },
    isInExperimentGroup: group === Group.experiment,
  };
};
